// src/admin/shell/TweaksPanel.tsx
// Per-user theme + density preference, persisted in localStorage. The values
// are applied as CSS classes on the AppShell root in AppShell.tsx; this panel
// just reads/writes the same hook.
import { useState } from 'react';
import { Sliders, X } from 'lucide-react';
import { useTweaks, type ThemeVariant, type Density } from './useTweaks';
import styles from './TweaksPanel.module.css';

const VARIANTS: ThemeVariant[] = ['classic', 'ink', 'daylight'];
const DENSITIES: Density[] = ['compact', 'comfortable', 'relaxed'];

export default function TweaksPanel() {
  const [open, setOpen] = useState(false);
  const { variant, density, setVariant, setDensity } = useTweaks();

  if (!open) {
    return (
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen(true)}
        aria-label="Open theme tweaks"
        title="Theme tweaks"
      >
        <Sliders size={16} />
      </button>
    );
  }

  return (
    <div className={styles.panel} role="dialog" aria-label="Theme tweaks">
      <div className={styles.head}>
        <span className={styles.title}>Tweaks</span>
        <button
          type="button"
          className={styles.close}
          onClick={() => setOpen(false)}
          aria-label="Close tweaks"
        >
          <X size={14} />
        </button>
      </div>
      <div className={styles.body}>
        <div className={styles.section}>
          <span className={styles.label}>Theme</span>
          <div className={styles.seg}>
            {VARIANTS.map(v => (
              <button
                key={v}
                type="button"
                onClick={() => setVariant(v)}
                className={v === variant ? styles.on : ''}
              >
                {v}
              </button>
            ))}
          </div>
        </div>
        <div className={styles.section}>
          <span className={styles.label}>Density</span>
          <div className={styles.seg}>
            {DENSITIES.map(d => (
              <button
                key={d}
                type="button"
                onClick={() => setDensity(d)}
                className={d === density ? styles.on : ''}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
